import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @returns {Promise<FetchSmartProposalResponse>}
 */
export function requestForGetProposalDeatil(value) {
  return fetch.patch(`${BASE_URL}/api/public/business-proposal/viewProposal`, {
    ...value,
  });
}

/**
 *
 * @returns {Promise<FetchSmartProposalResponse>}
 */
 export function requestForAcceptProposalDeatil(value) {  
  return fetch.patch(`${BASE_URL}/api/public/business-proposal/acceptProposal`, {
    ...value,
  });
}

/**
 *
 * @returns {Promise<FetchSmartProposalResponse>}
 */
 export function requestForUpdateTimeView(value) { 
  return fetch.patch(`${BASE_URL}/api/public/business-proposal/updateViewTime`, {
    ...value,
  });
}





